// src/features/business-functions/state/accountAtoms.js
import { atom } from 'recoil';
import { DEFAULT_ACCOUNT_TAB } from '../constants/accountConstants';

/** Full account detail object fetched from API */
export const accountDetailAtom = atom({
  key: 'bf_accountDetailAtom_v1',
  default: null,
});

/** Overview analytics stats for the account */
export const accountStatsAtom = atom({
  key: 'bf_accountStatsAtom_v1',
  default: {
    totalWorkspaces: 0,
    activeUsers: 0,
    totalTables: 0,
    totalAutomations: 0,
    trend: {},
    chartData: [],
    distribution: [],
    recentActivity: [],
  },
});

/** Workspace list for the account */
export const accountWorkspacesAtom = atom({
  key: 'bf_accountWorkspacesAtom_v1',
  default: { workspaces: [], total_count: 0 },
});

/** Active tab key — synced with URL ?tab= search param */
export const accountActiveTabAtom = atom({
  key: 'bf_accountActiveTabAtom_v1',
  default: DEFAULT_ACCOUNT_TAB,
});

/** Bump to refetch organisation account lists (sidebar + hub). */
export const organisationAccountsRefreshAtom = atom({
  key: 'bf_organisationAccountsRefreshAtom_v1',
  default: 0,
});
